import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  marginFeature: {
    margin: 0,
  },
  textAlighFeature: {
    textAlign: 'center',
  },
  boxFeature: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: 0,
  },
  leaves: {
    height: '100%',
    overflowY: 'scroll',
    overflowX: 'hidden',
  },
  noLeaves: {
    backgroundColor: 'white',
    border: '1px solid #ccc',
    padding: 10,
    textAlign: 'left',
    fontSize: 16,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
  },
}));
